/**
 * Product compare toasts (product-compare-toast-host).
 */
(function () {
  'use strict';

  const productCompare = window.ProductCompare;

  if (!productCompare || customElements.get("product-compare-toast-host")) {
    return;
  }

  const { getCompareLocale } = productCompare;

	class ProductCompareToastHost extends HTMLElement {
		static AUTO_DISMISS_MS = 5000;

		initialized = false;

		connectedCallback() {
			if (this.initialized) {
				return;
			}

			this.initialized = true;

			if (!this.classList.contains('product-compare-toast-host')) {
				this.classList.add('product-compare-toast-host');
			}
		}

		disconnectedCallback() {
			this.initialized = false;
		}

		/**
		 * @param {string} message
		 * @param {'success' | 'error'} [variant]
		 */
		show(message, variant = 'success') {
			const toast = document.createElement('div');

			toast.className = `product-compare-toast product-compare-toast--${variant}`;
			toast.setAttribute('role', variant === 'error' ? 'alert' : 'status');

			const iconMarkup =
				variant === 'error'
					? '<span class="product-compare-toast__icon" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/><path d="M6 6l8 8M14 6l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>'
					: '<span class="product-compare-toast__icon" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/><path d="M6 10.5l2.5 2.5L14 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

			toast.innerHTML = `${iconMarkup}<p class="product-compare-toast__message"></p><button type="button" class="product-compare-toast__close" aria-label="${getCompareLocale('compare_toast_close') || 'Close'}">×</button>`;

			const messageEl = toast.querySelector('.product-compare-toast__message');

			if (messageEl) {
				messageEl.textContent = message;
			}

			const dismiss = () => {
				toast.classList.add('product-compare-toast--leaving');

				toast.addEventListener(
					'transitionend',
					() => {
						toast.remove();
					},
					{ once: true },
				);

				window.setTimeout(() => {
					if (toast.isConnected) {
						toast.remove();
					}
				}, 300);
			};

			toast.querySelector('.product-compare-toast__close')?.addEventListener('click', dismiss);

			this.appendChild(toast);

			window.setTimeout(dismiss, ProductCompareToastHost.AUTO_DISMISS_MS);
		}
	}

  customElements.define("product-compare-toast-host", ProductCompareToastHost);
})();
